import React, { useState, useRef } from 'react';
import Papa from 'papaparse';
import { bulkImportLeads } from '../api';

const CRM_FIELDS = [
  { key: "name", label: "Name", required: true },
  { key: "phone", label: "Phone", required: true },

  { key: "lead_date", label: "Date" },
  

  { key: "email", label: "Email" },
  { key: "city", label: "City" },
  { key: "source", label: "Source Platform" },
  { key: "campaign_name", label: "Campaign Name" },
  { key: "product_interest", label: "Product Interest" },
  { key: "budget_cr", label: "Budget (Cr)" },
  { key: "priority", label: "Priority (hot/warm/cold)" },

  { key: "stage", label: "Stage" },
  { key: "follow_up", label: "Follow-up" },

  { key: "notes", label: "Question" },
];

function downloadTemplate() {
  const headers = CRM_FIELDS.map(f => f.label).join(',');
  const sample =
  "Rajesh Kumar,+91 98765 43210,2026-07-24,rajesh@email.com,Delhi,Meta (Facebook),FB_FarmEstate_June26,Farm Estate,1.5,warm,New Lead,2026-07-25,Is the property ready for possession?";
  const blob = new Blob([headers + '\n' + sample], { type: 'text/csv' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = 'aranyaka_leads_template.csv';
  a.click();
}

export default function UploadLeads() {
  const [csvData, setCsvData] = useState(null);
  const [headers, setHeaders] = useState([]);
  const [mapping, setMapping] = useState({});
  const [importing, setImporting] = useState(false);
  const [result, setResult] = useState(null);
  const [drag, setDrag] = useState(false);
  const fileRef = useRef();

  const parseFile = (file) => {
    Papa.parse(file, {
      header: false,
      skipEmptyLines: true,
      complete: (res) => {
        const [hdrs, ...rows] = res.data;
        setHeaders(hdrs);
        setCsvData(rows);
        // Auto-map by guessing column names
        const autoMap = {};
        CRM_FIELDS.forEach(f => {
          const idx = hdrs.findIndex(h =>
            h.toLowerCase().replace(/\s/g,'').includes(f.key.replace('_','')) ||
            h.toLowerCase().includes(f.label.toLowerCase().split(' ')[0])
          );
          if (idx >= 0) autoMap[f.key] = idx.toString();
        });
        setMapping(autoMap);
        setResult(null);
      }
    });
  };

  const handleDrop = (e) => {
    e.preventDefault(); setDrag(false);
    const file = e.dataTransfer.files[0];
    if (file?.name.endsWith('.csv')) parseFile(file);
  };

  const doImport = async () => {
    setImporting(true);
    try {
      const leads = csvData.map(row => {
        const lead = {};
        CRM_FIELDS.forEach(f => {
          const idx = mapping[f.key];
          if (idx !== undefined && idx !== '') lead[f.key] = row[parseInt(idx)]?.trim() || '';
        });
        return lead;
      }).filter(l => l.name && l.phone);

      const res = await bulkImportLeads(leads);
      setResult(res.data);
      setCsvData(null); setHeaders([]); setMapping({});
    } catch (err) {
      setResult({ error: err.response?.data?.error || 'Import failed' });
    } finally {
      setImporting(false);
    }
  };

  return (
    <div style={{ display:'flex', flexDirection:'column', height:'100%' }}>
      <div className="page-header">
        <div>
          <div className="page-title">CSV Upload</div>
          <div className="page-subtitle">Bulk import leads from a spreadsheet</div>
        </div>
        <button className="btn btn-sm" onClick={downloadTemplate}>⬇ Download template</button>
      </div>

      <div className="page-body">
        <div style={{ maxWidth:'700px' }}>
          {result && (
            <div style={{ background: result.error ? '#FCEBEB' : '#E1F5EE', borderRadius:'8px', padding:'14px 16px', marginBottom:'16px', fontSize:'13px', color: result.error ? '#A32D2D' : '#0F6E56' }}>
              {result.error ? (
  `Error: ${result.error}`
) : (
  <>
    <div>
      ✓ Imported {result.imported} leads. {result.skipped} duplicates skipped.
      {result.errors?.length
        ? ` ${result.errors.length} rows had errors.`
        : ""}
    </div>

    {result.errors?.length > 0 && (
      <div style={{ marginTop: 10, color: "#A32D2D" }}>
        {result.errors.slice(0, 5).map((item, index) => (
          <div key={index} style={{ marginBottom: 4 }}>
            {item.name || "Unknown"} ({item.phone || "No phone"}):{" "}
            {item.error}
          </div>
        ))}
      </div>
    )}
  </>
)}
            </div>
          )}

          {!csvData ? (
            <>
              <div
                className={`drop-zone${drag ? ' drag' : ''}`}
                onDragOver={e => { e.preventDefault(); setDrag(true); }}
                onDragLeave={() => setDrag(false)}
                onDrop={handleDrop}
                onClick={() => fileRef.current?.click()}
              >
                <div className="drop-zone-icon">📄</div>
                <p><span>Click to choose</span> or drag and drop your CSV file here</p>
                <p style={{ marginTop:'6px', fontSize:'11px' }}>Supports .csv files · up to 5,000 rows</p>
              </div>
              <input ref={fileRef} type="file" accept=".csv" style={{ display:'none' }}
                onChange={e => e.target.files[0] && parseFile(e.target.files[0])} />
              <div style={{ marginTop:'20px', background:'#fff', border:'0.5px solid rgba(0,0,0,0.1)', borderRadius:'12px', padding:'16px' }}>
                <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', marginBottom:'10px', textTransform:'uppercase', letterSpacing:'0.05em' }}>Accepted column names</div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'6px' }}>
                  {CRM_FIELDS.map(f => (
                    <div key={f.key} style={{ fontSize:'12px', display:'flex', alignItems:'center', gap:'6px' }}>
                      <span style={{ color: f.required ? '#E24B4A' : '#1D9E75' }}>{f.required ? '* ' : '✓ '}</span>
                      {f.label}
                    </div>
                  ))}
                </div>
                <div style={{ fontSize:'11px', color:'#aaa', marginTop:'10px' }}>* Required fields</div>
              </div>
            </>
          ) : (
            <div className="card">
              <div style={{ fontSize:'14px', fontWeight:'600', marginBottom:'4px' }}>Map your columns</div>
              <div style={{ fontSize:'12px', color:'#888', marginBottom:'16px' }}>{csvData.length} rows detected · Match each CRM field to a column in your file</div>
              <div className="mapping-grid">
                {CRM_FIELDS.map(f => (
                  <div key={f.key} style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                    <div style={{ flex:1, fontSize:'12px', background:'#f5f5f3', padding:'7px 10px', borderRadius:'6px', color:'#666' }}>
                      {f.label}{f.required ? ' *' : ''}
                    </div>
                    <svg viewBox="0 0 24 24" style={{ width:'14px', color:'#aaa', fill:'none', stroke:'currentColor', strokeWidth:2, flexShrink:0 }}><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                    <select
                      className="form-input"
                      style={{ flex:1, fontSize:'12px', padding:'6px 8px' }}
                      value={mapping[f.key] ?? ''}
                      onChange={e => setMapping(prev => ({ ...prev, [f.key]: e.target.value }))}
                    >
                      <option value="">— skip —</option>
                      {headers.map((h, i) => <option key={i} value={i}>{h}</option>)}
                    </select>
                  </div>
                ))}
              </div>
              <div style={{ fontSize:'11px', color:'#888', marginBottom:'16px' }}>
                Preview: {csvData.slice(0,3).map((r, i) => <span key={i} style={{ fontFamily:'monospace', marginRight:'8px' }}>{r[0]}</span>)}
              </div>
              <div style={{ display:'flex', gap:'8px' }}>
                <button className="btn btn-primary" onClick={doImport} disabled={importing}>
                  {importing ? 'Importing…' : `⬆ Import ${csvData.length} leads`}
                </button>
                <button className="btn" onClick={() => { setCsvData(null); setHeaders([]); }}>Cancel</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
